module.exports = __webpack_public_path__ + "img/santa_catarina.a161bee7.jpg";